// Central registry of all components in the library
// This file is auto-generated by scripts/generate-component-registry.js
// DO NOT EDIT MANUALLY - it will be overwritten!

export const COMPONENT_NAMES = ['Button', 'Icon', 'Popover', 'SectionHeader'] as const;

export type ComponentName = (typeof COMPONENT_NAMES)[number];

// Auto-generated on: 2026-02-13T21:11:40.347Z
// Found components: Button, Icon, Popover, SectionHeader
